import request2 from './request2'


const api2 = {
    
    getToken(data) {
      return request2({
          url: window.config.api + '/experiments/login',
           method: 'post',
           headers: {"Content-Type": "application/json"},
            data: JSON.stringify({
              username: 'admin',
              password: 'wlw-rd.123!@#'
            })
      })
    },
    GrtToken(){
      return request2({
        url: window.config.api2 + "/getToken",
        method: "get",
        params:{
          
        }
      });
    },
    GetappKey: (facilityType) => {
      return request2({
        url: window.config.SPJQ + "/artemis/api2/artemis/v1/agreementService/securityParam/appKey/26208115",
        method: "get",
        headers: {
          'X-Ca-Key':'Basic blhtMlBOX25Pd05QbW1ldGF6RWl0Z2l1VzJjYTpWaXR4b2N5clA2ZEswcGs0YVVZVjFhbm1wSVFh',
          'X-Ca-Signature':'172.18.13.135:8280'
        },
        params:{
          facilityType
        }
      });
    },
    selectSonFacilityByFacilityType: (facilityType) => {
      return request2({
        url: window.config.api2 + "/selectSonFacilityByFacilityType",
        method: "get",
        params:{
          facilityType
        }
      });
    },
    // 获取设备最新定位信息
    devicelatestpositions: (arr) => {
      return request2({
        url: window.config.api2 + "/devicelatestpositions",
        method: "get",
        params:{
          arr
        }
      });
    }, 
    // 超重接口
    
    findPointDeviceDataRecordList: (data) => {
      return request2({
        url: window.config.api2 + "/experiments/car/findPointDeviceDataRecordList",
        method: "get",
        headers: {
          'Authorization':'Bearer'+sessionStorage.getItem('token'),
        },
        params:{
          _t:parseInt(new Date().getTime()/1000),
          data
        }
      });
    }, 
    // 道路、桥隧情况等级统计
    statisticsByOftenId: () => {
      return request2({
        url: window.config.api2 + "/test/statisticsByOftenId",
        method: "get",
        params:{
          
        }
      });
    }, 
    countRoadAndBridge: () => {
      return request2({
        url: window.config.api2 + "/countRoadAndBridge",
        method: "get",
        params:{}
      });
    },
    //1.1.	获取复兴大桥监测数据
    findAllSteeve: (code) => {
      return request2({
        // url: window.config.api2 + "/experiments/bridge/v1.0.0/experiments/steeve/findAllSteeve",
        url:window.config.api2 +'/experiments/steeve/findAllSteeve',
        method: "get",
        headers: {
          'Authorization':'Bearer'+sessionStorage.getItem('token'),
        },
        params:{
          _t:parseInt(new Date().getTime()/1000)
        }
      });
    }, 
    //1.2.	获取九堡大桥过去24小时总体数据
    findRecentData: () => {
      return request2({
        // url: window.config.api2 + "/experiments/bridge/v1.0.0/experiments/NfBridge/findRecentData",
        url: window.config.api2 + "/experiments/NfBridge/findRecentData",
        method: "get",
        headers: {
          'Authorization':'Bearer'+sessionStorage.getItem('token'),
        },
        params:{
          _t:parseInt(new Date().getTime()/1000)
        }
      });
    },
    //1.3.	获取九堡大桥设备最新上报数据
    findLastData: (deviceId) => {
      return request2({
        // url: window.config.api2 + "/experiments/bridge/v1.0.0/experiments/NfBridge/findLastData",
        url: window.config.api2 + "/experiments/NfBridge/findLastData",
        headers: {
          'Authorization':'Bearer'+sessionStorage.getItem('token'),
        },
        method: "get",
        params:{
          _t:parseInt(new Date().getTime()/1000),
          deviceId
        }
      });
    },
    //1.4.	获取九堡大桥设备时间段数据详情
    findBridge: (startTime, endTime,deviceId) => {
      return request2({
        // url: window.config.api2 + "/experiments/bridge/v1.0.0/experiments/NfBridge/findBridge",
        url: window.config.api2 + "/experiments/NfBridge/findBridge",
        method: "get",
        headers: {
          'Authorization':'Bearer'+sessionStorage.getItem('token'),
        },
        params:{
          _t:parseInt(new Date().getTime()/1000),
          startTime ,
          endTime ,
          deviceId
        }
      });
    },
    /*
     *  1.	治超接口
     */
    //1.1.	获取监测点列表
    findPointDeviceList: () => {
      return request2({
        url: window.config.api2 + "/experiments/openAPI/car/v1.0/findPointDeviceList",
        method: "get",
        headers: {
          'Authorization':'Bearer'+sessionStorage.getItem('token'),
        },
        params:{
          
        }
      });
    },
    // 获取车辆信息
    selectHourcar: (data) => {
      return request2({
        url: window.config.api2 + "/selectHourcar",
        method: "get",
        params:data
      });
    },
    selectTypeCar: (data) => {
      return request2({
        url: window.config.api2 + "/selectTypeCar",
        method: "get",
        params:data
      });
    },
    // // 结构沉降
    // findPointDeviceList: () => {
    //   return request2({
    //     // url: window.config.api2 + "/experiments/tunnel/v1.0.0/experiments/tunnel/findPointDeviceList",
    //     url: window.config.api2 + "/experiments/tunnel/findPointDeviceList",
    //     method: "get",
    //     headers: {
    //       'Authorization':'Bearer'+sessionStorage.getItem('token'),
    //     },
    //     params:{
    //       _t:parseInt(new Date().getTime()/1000),
    //     }
    //   });
    // },
    TunnelfindPointDeviceDataRecordList: (data) => {
      return request2({
        // url: window.config.api2 + "/experiments/tunnel/v1.0.0/experiments/tunnel/findPointDeviceDataRecordList",
        url: window.config.api2 + "/experiments/tunnel/findPointDeviceDataRecordList",
        method: "get",
        headers: {
          'Authorization':'Bearer'+sessionStorage.getItem('token'),
        },
        params:{
          _t:parseInt(new Date().getTime()/1000),
          ...data
        }
      });
    },
    selectBridgeWithinConstruction(data){
      return request2({
        url: window.config.api2 + "/selectBridgeWithinConstruction",
        method: "get",
        params:data
      });
    },
    // 超重接口
    //1.1.	获取监测点列表
    findPointDeviceList2: () => {
      return request2({
        // url: window.config.api2 + "/experiments/openAPI/car/v1.0/findPointDeviceList",
        url: window.config.api2 + "/experiments/car/findPointDeviceList",
        method: "get",
        headers: {
          'Authorization':'Bearer'+sessionStorage.getItem('token'),
        },
        params:{
          _t:parseInt(new Date().getTime()/1000),
        }
      });
    },
    //1.1.	获取监测点列表
    getAllFindPointDeviceList: (data) => {
        return request2({
            url: window.config.api2 + "/findPoint/getAllFindPointDeviceList",
            method: "get",
            params:data
        });
    },
    selectPointTypeCarByPointAndTime: (data) => {
      return request2({
        url: window.config.api2 + "/selectPointTypeCarByPointAndTime",
        method: "get",
        params:{_t:parseInt(new Date().getTime()/1000),...data}
      });
    },
    devicehistorypositions: (data) => {
      return request2({
        url: window.config.api2 + "/devicehistorypositions",
        method: "get",
        params:data
      });
    },
    // 巡更点大屏展示
    getAllPatrolPoint: (data) => {
      return request2({
        url: window.config.api2 + "/temporary/getAllPatrolPoint",
        method: "get",
        params:data
      });
    },
    // 大屏巡更轨迹
    getPatrolTrajectory: (data) => {
      return request2({
        url: window.config.api2 + "/patrolling/getPatrolTrajectory",
        method: "get",
        params:data
      });
    },
    cha_bhlb: (data) => {
      return request2({
        url: window.config.api3 + "chabh",
        method: "get",
        // params:data
      });
    },
    // findControlUnitByUnitCode: () => {
    //   return request2({
    //     url: 'https://172.18.6.99:9999/artemis/api2/common/v1/remoteControlUnitRestService/findControlUnitByUnitCode?unitCode=13',
    //     method: "get",
    //     // params:data
    //   });
    // },

    /*
    * *分页获取组织树
    */
   callApiGetSecurity(data){
    return request2({
      url: window.config.api2 + "/callApiGetSecurity",
      method: "get",
      params:data
    })
  },
    /*
    * *根据父组织编号查询组织树
    */
   findControlUnitByUnitCode(data){
    return request2({
      url: window.config.api2 + "/findControlUnitByUnitCode",
      method: "get",
      params:data
    })
  },
    getCarOutLimitsByObj(data){
        return request2({
            url: window.config.api2 + "/carOutLimits/getCarOutLimitsByObj",
            method: "post",
            data
        })
    },
    /*
    * *根据组织编号与资源类型分页获取资源信息
    */
   findResourcePageByTreeNode(data){
    return request2({
      url: window.config.api2 + "/findResourcePageByTreeNode",
      method: "get",
      params:data
    })
  },

  /*
    * *病害分析
  */
 diseaseAnalysisHeatMeter(data){
    return request2({
      url: window.config.api2 + "/diseaseAnalysisHeatMeter",
      method: "get",
      params:data
    })
  },
  //
  diseaseAnalysisHeatMeterselectAllMainFacility(){
    return request2({
      url: window.config.api2 + "/diseaseAnalysisHeatMeterselectAllMainFacility",
      method: "get",
    })
  },
  diseaseAnalysisHeatMeterByFacilityUuid(data){
    return request2({
      url: window.config.api2 + "/diseaseAnalysisHeatMeterByFacilityUuid",
      method: "get",
      params:data
    })
  },
  // 根据检测点查询超重车辆信息
  selectOutCarByTimeAndPointId(data){
    return request2({
      url: window.config.api2 + "/selectOutCarByTimeAndPointId",
      method: "get",
      params:data
    })
  },
  selectRepairSituationByReportId(data){
    return request2({
      url: window.config.api2 + "/selectRepairSituationByReportId",
      method: "get",
      params:data
    })
  },
  selectSonFacilityInfoByFacilityType(data){
    return request2({
      url: window.config.api2 + "/selectSonFacilityInfoByFacilityType",
      method: "get",
      params:data
    })
  },
  getRouteParameterGroupByFacility(data){
    return request2({
      url: window.config.api2 + "/routeParameter/getRouteParameterGroupByFacility",
      method: "get",
      params:data
    })
  },
  // 泵站实时信息
  selectDingqiaoNow(data){
    return request2({
      url: window.config.api4 + "/selectDingqiaoNow",
      method: "get",
      params:data
    })
  },
  // 泵站水位信息
  selectPumpStationByTime(data){
    return request2({
      url: window.config.api4 + "/selectPumpStationByTime",
      method: "get",
      params:data
    })
  },
  

  // 模糊搜索自设施
  selectFacilityByFacilityName: (data) => {
    return request2({
      url: window.config.api2 + "/selectFacilityByFacilityName",
      method: "get",
      params:data
    });
  },
  //登陆
  login: data => {
    return request2({
      url: window.config.api2 + "/login",
      method: "post",
      data
    });
  },
  // 查询文件夹
  selectFile: (areaFacilityUuid ,type) => {
    return request2({
      url: window.config.api2 + "/selectFile",
      method: "get",
      params:{
        areaFacilityUuid,
        type
      }
    });
  },
  // 新增文件夹
  insertAndUpdateFileCode: (data) => {
    return request2({
      url: window.config.api2 + "/insertAndUpdateFileCode",
      method: "post",
      data
    });
  },
  selectProjectFile: (data) => {
    return request2({
      url: window.config.api2 + "/selectProjectFile",
      method: "get",
      params:data
    });
  },

  // 查询市
  selectCity: () => {
    return request2({
      url: window.config.api2 + "/pca/selectCity",
      method: "post",
      data: {

      }
    });
  },
  // 查询杭州市
  selectHZ: e => {
    return request2({
      url: window.config.api2 + "/pca/selectHZ",
      method: "post",
      data: {
        e
      }
    });
  },
  // 根据市编号查询区
  selectA: e => {
    return request2({
      url: window.config.api2 + "/pca/selectA",
      method: "get",
      params: {
        cityCode:e
      }
    });
  },

  // 统计市下区的设施量
  countCityFacility: (cityCode) => {
    return request2({
      url: window.config.api2 + "/countCityFacility",
      method: "get",
      params:{
        cityCode
      }
    });
  },
  // 修改区信息
  updateAreaZ: data => {
    return request2({
      url: window.config.api2 + "/updateAreaZ",
      method: "post",
      data
    });
  },
  // 查询设施
  selectFacility: (data) => {
    let userUuid = JSON.parse(sessionStorage.getItem('userInfo')).uuid;
    data.userUuid = userUuid;
    return request2({
      url: window.config.api2 + "/selectFacility",
      method: "get",
      params: data
    });
  },
  // 根据单位类型和单位名称进行查询
  selectCompanyByCompanyType: (data) => {
    return request2({
      url: window.config.api2 + "/selectCompanyByCompanyType",
      method: "get",
      params: data
    });
  },

  // 根据Name查询部件小类
  selectPartsByName: partsName => {
    return request2({
      url: window.config.api2 + "/selectParts",
      method: "get",
      params: {
        partsName
      }
    });
  },
  // 根据设施id查询部件小类
  selectParts: facilityUuid => {
    return request2({
      url: window.config.api2 + "/selectParts",
      method: "get",
      params: {
        facilityUuid
      }
    });
  },
  // 添加主设施  添加子设施
  insertFacility: data => {
    return request2({
      url: window.config.api2 + "/insertFacility",
      method: "post",
      data
    });
  },
  // 添加部件小类
  insertFacilityPart: data => {
    return request2({
      url: window.config.api2 + "/insertFacilityPart",
      method: "post",
      data
    });
  },
  // 添加部件小类
  deleteFacility: facilityId => {
    return request2({
      url: window.config.api2 + "/deleteFacility",
      method: "get",
      params: {
        facilityId
      }
    });
  },
  deleteFacilityPart: data => {
    return request2({
      url: window.config.api2 + "/deleteFacilityPart",
      method: "post",
      data
    });
  },
  //主设施概述 子设施概述
  selectFacilitySunmm: facilityUuid => {
    return request2({
      url: window.config.api2 + "/selectFacility",
      method: "get",
      params: {
        facilityUuid
      }
    });
  },
  //根据子设施url生成二维码
  facilityUrlToQc(data) {
    return request2({
      url: window.config.api2 + "/facilityUrlToQc",
      method: "post",
      data
    });
  },
  // 导入导出资料卡
  // 导出桥梁excel
  bridgeEmportExcel(data) {
    return request2({
      url: config.api2 + "/bridgeEmportExcel",
      method: "get",
      responseType: "blob",
      params:data
    });
  },
  roadEmportExcel(data) {
    return request2({
      url: config.api2 + "/roadEmportExcel",
      method: "get",
      responseType: "blob",
      params:data
    });
  },

  //导入主设施，子设施
  facilityImportExcel: (areaCode, file) => {
    return request2({
      url: window.config.improtExcel + "/facilityImportExcel ",
      method: "post",
      params: {
        areaCode,
        file
      }
    });
  },
  //编辑主设施
  updateFacility(data) {
    return request2({
      url: config.api2 + "/updateFacility",
      method: "post",
      data
    });
  },

  // 1=主设施类型 2=子设施类型 3=工程进度
  //获取常用字段
  getOftenType(commonType) {
    return request2({
      url: config.api2 + "/selectOftenType",
      method: "get",
      params: {
        commonType
      }
    });
  },

  //新增常用字段
  addOftenType(commonType, commonName, sonCommonName) {
    return request2({
      url: config.api2 + "/insertOrUpdateOftenType",
      method: "post",
      data: {
        commonType,
        commonName,
        sonCommonName
      }
    });
  },

  //修改常用字段
  updateOftenType(commonType, commonName, sonCommonName, oftenId) {
    return request2({
      url: config.api2 + "/insertOrUpdateOftenType",
      method: "post",
      data: {
        commonType,
        commonName,
        sonCommonName,
        oftenId
      }
    });
  },

  //删除常用字段
  deleteOftenType(oftenId) {
    return request2({
      url: config.api2 + "/delectOftenType",
      method: "get",
      params: {
        oftenId
      }
    });
  },

  //查询损害类型（树型）
  selectDamageBySZF() {
    return request2({
      url: config.api2 + "/selectDamageBySZFB",
      method: "get"
    });
  },

  //查询损害类型（平级）
  selectDamageBySZFP() {
    return request2({
      url: config.api2 + "/selectDamageBySZF",
      method: "get"
    });
  },

  //添加损害类型
  addDamageType(damageName, companyType, source_type) {
    return request2({
      url: config.api2 + "/insertOrUpdateDamageType",
      method: "post",
      data: {
        damageName,
        companyType,
        source_type
      }
    });
  },

  //添加损害类型
  deleteDamageType(damageId) {
    return request2({
      url: config.api2 + "/deleteDamageType",
      method: "get",
      params: {
        damageId
      }
    });
  },

  //编辑损害类型
  updateDamageType(damageId, damageName, companyType, source_type) {
    return request2({
      url: config.api2 + "/insertOrUpdateDamageType",
      method: "post",
      data: {
        damageId,
        damageName,
        companyType,
        source_type
      }
    });
  },

  //病害类型中的新增部件小类
  addParts(data) {
    return request2({
      url: config.api2 + "/insertOrUpdateParts",
      method: "post",
      data
    });
  },

  //病害类型中的删除部件小类
  deleteParts(params) {
    return request2({
      url: config.api2 + "/delectParts",
      method: "get",
      params
    });
  },

  //添加构件
  addMember(componentName, partUuid) {
    return request2({
      url: config.api2 + "/insertComponentType",
      method: "post",
      data: {
        componentName,
        partUuid
      }
    });
  },

  //删除构件
  deleteMember(componentTypeUuid) {
    return request2({
      url: config.api2 + "/deleteComponentType",
      method: "get",
      params: {
        componentTypeUuid
      }
    });
  },
  //查询损害
  selectDamage(componentTypeUuid) {
    return request2({
      url: config.api2 + "/selectDisease",
      method: "get",
      params: {
        componentTypeUuid
      }
    });
  },

  //添加损害类型
  addDamage(data) {
    return request2({
      url: config.api2 + "/insertOrUpdateDamageType",
      method: "post",
      data
    });
  },

  //删除损害
  deleteDisease(damageUuid, componentTypeUuid) {
    return request2({
      url: config.api2 + "/deleteDisease",
      method: "get",
      params: {
        damageUuid,
        componentTypeUuid
      }
    });
  },

  //查询设施基础管理-部件小类-构件
  selectComponent(params) {
    return request2({
      url: config.api2 + "/selectComponent",
      method: "GET",
      params
    });
  },



  //设施道路类型数据查询
  selectRoad(facilityUuid) {
    return request2({
      url: config.api2 + "/selectRoad",
      method: "GET",
      params: {
        facilityUuid
      }
    });
  },
  //设施道路类型数据查询
  updateRoad(data) {
    return request2({
      url: config.api2 + "/updateRoad",
      method: "post",
        data
    });
  },
  //设施桥梁类型数据查询
  selectBridge(facilityUuid) {
    return request2({
      url: config.api2 + "/selectBridge",
      method: "GET",
      params: {
        facilityUuid
      }
    });
  },
  //设施道路类型数据 修改
  updateBridge(data) {
    return request2({
      url: config.api2 + "/updateBridge",
      method: "post",
      data
    });
  },
  tunnelExport(data) {
    return request2({
      url: config.api2 + "/tunnelExport",
      method: "get",
      responseType: "blob",
      params:data
    });
  },
  // 隧道
  //设施隧道类型数据查询
  selectTunnel(facilityUuid) {
    return request2({
      url: config.api2 + "/selectTunnel",
      method: "GET",
      params: {
        facilityUuid
      }
    });
  },
  //设施隧道类型数据修改
  updateTunnel(data) {
    return request2({
      url: config.api2 + "/updateTunnel",
      method: "post",
      data
    });
  },
  //设施隧道类型数据修改
  updateSelectTunnel(data) {
    return request2({
      url: config.api2 + "/updateSelectTunnel",
      method: "post",
      data
    });
  },
  // 查询巡更点
  patrolSelect(facilityUuid) {
    return request2({
      url: config.api2 + "/patrol/selectByFacilityUuid",
      method: "GET",
      params: {
        facilityUuid
      }
    });
  },
  //添加And修改巡更点
  insertOrUpdatePatrol(data) {
    return request2({
      url: config.api2 + "/patrol/insertOrUpdatePatrol",
      method: "post",
      data
    });
  },
  // 查询巡更点
  deletePatrolById(patrolId) {
    return request2({
      url: config.api2 + "/patrol/deletePatrolById",
      method: "GET",
      params: {
        patrolId
      }
    });
  },
  //添加And修改巡更点
  inspection(data) {
    return request2({
      url: config.api2 + "/inspection",
      method: "post",
      data
    });
  },

  //给设施下部件小类添加构件
  insertComponent(data) {
    return request2({
      url: config.api2 + "/insertComponent",
      method: "post",
      data
    });
  },
  //查询构件
  selectComponentTypeByPartsId(partUuid) {
    return request2({
      url: config.api2 + "/selectComponentTypeByPartUuid",
      method: "get",
      params: {
        partUuid
      }
    });
  },

  //删除构件
  deleteComponets(componentUuid, sourceType) {
    return request2({
      url: config.api2 + "/deleteComponent",
      method: "get",
      params: {
        componentUuid,
        sourceType
      }
    });
  },
  //编辑构件
  updateComponets(data) {
    return request2({
      url: config.api2 + "/updateComponent",
      method: "post",
      data
    });
  },

  //导出excel
  componentExport(facilityUuid, partUuid) {
    return request2({
      url: config.api2 + "/componentExport",
      method: "get",
      responseType: "blob",
      params: {
        facilityUuid,
        partUuid
      }
    });
  },

  /*
   *2.1组织管理
   */

  // 2.1.2添加同级单位
  insertCompany(data) {
    return request2({
      url: config.api2 + "/insertCompany",
      method: "post",
      data
    });
  },
  // 2.1.3编辑单位And部门
  updateCompany(data) {
    return request2({
      url: config.api2 + "/updateCompany",
      method: "post",
      data
    });
  },
  //2.1.4删除单位And部门
  deleteCompany(companyId) {
    return request2({
      url: config.api2 + "/deleteCompany",
      method: "get",
      params: {
        companyId
      }
    });
  },
  //2.1.5单位And部门停用
  stopCompany(companyId, enable) {
    return request2({
      url: config.api2 + "/stopCompany",
      method: "get",
      params: {
        companyId,
        enable
      }
    });
  },
  // 2.1.6添加下级部门
  selectCompanyByNameAndStatus(data) {
    return request2({
      url: config.api2 + "/selectCompanyByNameAndStatus",
      method: "post",
      data
    });
  },

  /*
   *2.2用户管理
   */
  // 2.2.1添加用户
  insertUser(data) {
    return request2({
      url: config.api2 + "/insertUser",
      method: "post",
      data
    });
  },
  // 查询所有部门信息
  selectCompany(data) {
    return request2({
      url: config.api2 + "/selectCompany",
      method: "GET",
      params:data
    })
  },
  // 2.2.1根据部门id查询所有用户
  selectUser(data) {
    return request2({
      url: config.api2 + "/selectUser",
      method: "get",
      params: data
    })
  },
  // 2.2.1根据用户名和状态搜索
  selectUserByNameAndEnablez(companyId) {
    return request2({
      url: config.api2 + "/selectUserByNameAndEnablez",
      method: "get",
      params: {
        companyId
      }
    })
  },
  //  更改用户
  updateUser(data) {
    return request2({
      url: config.api2 + "/updateUser",
      method: "post",
      data
    });
  },
  //重置密码
  reUpdateUserPassword(data) {
    return request2({
      url: config.api2 + "/reUpdateUserPassword",
      method: "post",
      data
    });
  },

  // 菜单管理
  selectAllResources(companyId) {
    return request2({
      url: config.api2 + "/selectAllResources",
      method: "get",
      params: {
        companyId
      }
    })
  },
  //添加菜单
  insertOrupdateResources(data) {
    return request2({
      url: config.api2 + "/insertOrupdateResources",
      method: "post",
      data
    });
  },
  //删除菜单
  deleteResources(resourcesId) {
    return request2({
      url: config.api2 + "/deleteResources",
      method: "get",
      params: {
        resourcesId
      }
    })
  },
  /*
  *角色管理
  */

  //角色类型展示
  selectRoleType() {
    return request2({
      url: config.api2 + "/selectRoleType",
      method: "get",
      params: {

      }
    });
  },
  //添加角色类型
  insertRoleType(data){
    return request2({
      url: config.api2 + '/insertRoleType',
      method: 'post',
      data
    })
  },
  // 编辑角色类型
  updateRoleType(data){
    return request2({
      url: config.api2 + '/updateRoleType',
      method: 'post',
      data
    })
  },
  //删除角色类型
  deleteRoleType(roleTypeId){
    return request2({
      url: config.api2 + '/deleteRoleType',
      method: 'get',
      params: {
        roleTypeId
      }
    })
  },
  //删除角色
  deleteRole(roleId){
    return request2({
      url: config.api2 + '/deleteRole',
      method: 'get',
      params: {
        roleId
      }
    })
  },

  //角色添加权限
  insertRoleResources(data){
    return request2({
      url: config.api2 + '/insertRoleResources',
      method: 'post',
      data
    })
  },
  //根据角色id查询资源
  selectResourcesByRoleId(roleId){
    return request2({
      url: config.api2 + '/selectResourcesByRoleId',
      method: 'get',
      params: {
        roleId
      }
    })
  },

  //添加And修改角色
  insertAndUpdateRole(data){
    return request2({
      url: config.api2 + '/insertAndUpdateRole',
      method: 'post',
      data
    })
  },
  // 用户添加角色
  userAddRole(data){
    return request2({
      url: config.api2 + '/userAddRole',
      method: 'post',
      data
    })
  },
  // 用户添加角色
  deleteUserRoleByUserId(data){
    return request2({
      url: config.api2 + '/deleteUserRoleByUserId',
      method: 'get',
      params:data
    })
  },

  //查找所有损害
  selectDisease(){
    return request2({
      url: config.api2 + '/selectDamageType',
      method: 'get'
    })
  },

  //查找所有损害
  insertOrUpdateDisease(data){
    return request2({
      url: config.api2 + '/insertOrUpdateDisease',
      method: 'post',
      data
    })
  },

  selFeedbackByObj(data){
    return request2({
      url: config.api2 + '/feedback/selFeedbackByObj',
      method: 'post',
      data
    })
  },
  // 查询项目
  selectAllProject(data){
    return request2({
      url: config.api2 + '/selectAllProject',
      method: 'post',
      data
    })
  },
  // 添加项目
  insertProject(data){
    return request2({
      url: config.api2 + '/insertProject',
      method: 'post',
      data
    })
  },
  updateProject(data){
    return request2({
      url: config.api2 + '/updateProject',
      method: 'post',
      data
    })
  },
  // 项目添加子设施
  addFacilityToProject(data){
    return request2({
      url: config.api2 + '/addFacilityToProject',
      method: 'post',
      data
    })
  },
  removeProjectId(data){
    return request2({
      url: config.api2 + '/removeProjectId',
      method: 'get',
      params:data
    })
  },

  facilityHaveProject(data){
    return request2({
      url: config.api2 + '/facilityHaveProject',
      method: 'get',
      params:data
    })
  },
  updateFacilityProjectId(data){
    return request2({
      url: config.api2 + '/updateFacilityProjectId',
      method: 'get',
      params:data
    })
  },

  // 删除项目信息
  delectProject(data){
    return request2({
      url: config.api2 + '/delectProject',
      method: 'get',
      params:data
    })
  },

  // 批后监管
  selectBridgeWithinConstruction(data){
    return request2({
      url: config.api2 + '/selectBridgeWithinConstruction',
      method: 'get',
      params:data
    })
  },
  insertBridgeWithinConstruction(data){
    return request2({
      url: config.api2 + '/insertBridgeWithinConstruction',
      method: 'post',
      data
    })
  },
  updateBridgeWithinConstruction(data){
    return request2({
      url: config.api2 + '/updateBridgeWithinConstruction',
      method: 'post',
      data
    })
  },
  insertOrUpdateLongTerm(data){
    return request2({
      url: config.api2 + '/longTerm/insertOrUpdateLongTerm',
      method: 'post',
      data
    })
  },
  selectLongTermByObj(data){
    return request2({
      url: config.api2 + '/longTerm/selectLongTermByObj',
      method: 'post',
      data
    })
  },

  selectLongTermByObjTask(data){
    data = JSON.parse(JSON.stringify(data));
    data.page = data.pageNum;
    data.rows = data.pageSize;
    delete data.pageSize;
    delete data.pageNum;
    return request2({
      url: config.api2 + '/longTerm/selectLongTermByObjTask',
      method: 'post',
      data
    })
  },

  deleteBridgeWithinConstruction(data){
    return request2({
      url: config.api2 + '/deleteBridgeWithinConstruction',
      method: 'get',
      params:data
    })
  },
  componentByFacility(data){
    return request2({
      url: config.api2 + '/component/componentByFacility',
      method: 'get',
      params: data
    })
  },


  deleteLongTerm(params){
    return request2({
      url: config.api2 + '/longTerm/deleteLongTerm',
      method: 'get',
      params
    })
  },
  // 根据批后监管办件编号和时间查询图片信息
  selectFileCodeByCodeAndStartTimeAndEndTime(data){
    return request2({
      url: config.api2 + '/selectFileCodeByCodeAndStartTimeAndEndTime',
      method: 'get',
      params: data
    })
  },
  // 查询子设施是否与批后监管关联
  hasSupervisionFacility(data){
    return request2({
      url: config.api2 + '/hasSupervisionFacility',
      method: 'get',
      params: data
    })
  },
  // 删除子设施与批后监管关联
  replaceOrNotSupervisionFacility(data){
    return request2({
      url: config.api2 + '/replaceOrNotSupervisionFacility',
      method: 'get',
      params: data
    })
  },
  // 获取全部子设施
  selectCAZZ(){
    return request2({
      url: config.api2 + '/pca/selectCAZZ',
      method: 'get',
      params: {}
    })
  },
  // 复制主设施 生成子设施
  copyFacility(data){
    return request2({
      url: config.api2 + '/copyFacility',
      method: 'post',
      data
    })
  },
  //查找部分损害
  selectDiseaseTwo(params){
    return request2({
      url: config.api2 + '/selectDisease',
      method: 'get',
      params
    })
  },
  getSuiMonitorByObj(data){
    return request2({
      url: config.api2 + '/suiMonitor/getSuiMonitorByObj',
      method: 'post',
      data
    })
  },
  insertOrUpdateSuiMonitor(data){
    return request2({
      url: config.api2 + '/suiMonitor/insertOrUpdateSuiMonitor',
      method: 'post',
      data
    })
  },
  suiMonitorupdate(data){
    return request2({
      url: config.api2 + '/suiMonitor/update',
      method: 'get',
      params: data
    })
  },






  getTemporaryByObj(data){
    return request2({
      url: window.config.api2 + "/temporary/getTemporaryByObj",
      method: "post",
      data
    });
  },
  selectReportByObj(data){
    return request2({
      url: window.config.api2 + "/report/selectReportByObj",
      method: "post",
      data
    });
  },
  selectShebeiByObj(data){
    return request2({
      url: window.config.api2 + "/alarmReport/getAlarmReportByObj",
      method: "post",
      data
    });
  },
  getPatrolPlan(data){
    return request2({
      url: window.config.api2 + "/temporary/getPatrolPlan",
      method: "post",
      data
    });
  },
  CurSelectReportByObj(data){
    return request2({
      url: window.config.api2 + "/reportCuring/selectReportCuringByObj",
      method: "post",
      data
    });
  },
  longComponentTaskByCycleNum(params){
    return request2({
      url: window.config.api2 + "/longComponentTask/longComponentTaskByCycleNum",
      method: "get",
      params
    });
  },
  patrollingRecordDetailed(data){
    return request2({
      url: window.config.api2 + "/patrolling/patrollingRecordDetailed",
      method: "post",
      data
    })
  },
  getMaxCycleNumByTermUuid(params){
    return request2({
      url: window.config.api2 + "/longComponentTask/getMaxCycleNumByTermUuid",
      method: "get",
      params
    });
  },
  reportCuringReportCuringDetailed(params){
    return request2({
      url: window.config.api2 + "/reportCuring/reportCuringDetailed",
      method: "get",
      params
    });
  },
  examineReportGdExamine(data){
    return request2({
      url: window.config.api2 + "/examine/reportGdExamine",
      method: "post",
      data
    });
  },

  //获取公司
  companyGetUtilCompanyByCompanyType(params){
    return request2({
      url: window.config.api2 + "/company/getUtilCompanyByCompanyType",
      method: "get",
      params
    });
  },

  //获取部门
  companyGetDepartmentByCompanyId(params){
    return request2({
      url: window.config.api2 + "/company/getDepartmentByCompanyId",
      method: "get",
      params
    });
  },

  //获取用户
  userGetUserByCompanyId(params){
    return request2({
      url: window.config.api2 + "/user/getUserByCompanyId",
      method: "get",
      params
    });
  },

  //派单
  longComponentTaskLongComponentTaskDispatch(data){
    return request2({
      url: window.config.api2 + "/longComponentTask/longComponentTaskDispatch",
      method: "post",
      data
    });
  },

  getTermCycleTime(params){
    return request2({
      url: window.config.api2 + "/longTask/getTermCycleTime",
      method: "get",
      params
    });
  },

  getEachCycleLongRecord(data){
    return request2({
      url: window.config.api2 + "/longRecord/getEachCycleLongRecord",
      method: "post",
      data
    });
  },

  //数字城管
  getSzcgReportInfo(data){
    return request2({
      url: window.config.api2 + "/getSzcgReportInfo",
      method: "post",
      data
    });
  },

  getLongComponentTaskByTermUuidAndCycleNum(params){
    return request2({
      url: window.config.api2 + "/longComponentTask/getLongComponentTaskByTermUuidAndCycleNum",
      method: "get",
      params
    });
  },

  //获取材料或设备
  getMaterialType(params){
    return request2({
      url: window.config.api2 + "/materialType/getMaterialType",
      method: "get",
      params
    });
  },

  //查询二级材料或设备
  getMaterialTypeTwoByMaterialTypeUuid(params){
    return request2({
      url: window.config.api2 + "/materialTypeTwo/getMaterialTypeTwoByMaterialTypeUuid",
      method: "get",
      params
    });
  },

  //查询三级材料或设备
  getMaterialTypeThreeByMaterialTypeTwoUuid(params){
    return request2({
      url: window.config.api2 + "/materialTypeThree/getMaterialTypeThreeByMaterialTypeTwoUuid",
      method: "get",
      params
    });
  },

  //新增或编辑一级材料或设备
  insertOrUpdateMaterialType(data){
    return request2({
      url: window.config.api2 + "/materialType/insertOrUpdateMaterialType",
      method: "post",
      data
    });
  },

  //新增或编辑二级材料或设备
  insertOrUpdateMaterialTypeTwo(data){
    return request2({
      url: window.config.api2 + "/materialTypeTwo/insertOrUpdateMaterialTypeTwo",
      method: "post",
      data
    });
  },

  //新增或编辑三级材料或设备
  insertOrUpdateMaterialTypeThree(data){
    return request2({
      url: window.config.api2 + "/materialTypeThree/insertOrUpdateMaterialTypeThree",
      method: "post",
      data
    });
  },

  //查询四级表格
  getEquipmentByMaterialTypeThreeUuid(params){
    return request2({
      url: window.config.api2 + "/equipment/getEquipmentByMaterialTypeThreeUuid",
      method: "get",
      params
    });
  },

  //查询四级表格
  getMaterialByMaterialTypeThreeUuid(params){
    return request2({
      url: window.config.api2 + "/material/getMaterialByMaterialTypeThreeUuid",
      method: "get",
      params
    });
  },

  //新增四级
  insertOrUpdateEquipment(data){
    return request2({
      url: window.config.api2 + "/equipment/insertOrUpdateEquipment",
      method: "post",
      data
    });
  },
  //新增四级
  insertOrUpdateMaterial(data){
    return request2({
      url: window.config.api2 + "/material/insertOrUpdateMaterial",
      method: "post",
      data
    });
  },
  selectFacilityByLonLatC(params){
    return request2({
      url: window.config.api2 + "/selectFacilityByLonLatC",
      method: "get",
      params
    });
  },

  selectFacilityAndPartsAndComponent(params){
    return request2({
      url: window.config.api2 + "/selectFacilityAndPartsAndComponent",
      method: "get",
      params
    });
  },


  getLeveByDegree(params){
    return request2({
      url: window.config.api2 + "/disease/getLeveByDegree",
      method: "get",
      params
    });
  },

  insertOrUpdateReport(data){
    return request2({
      url: window.config.api2 + "/insertOrUpdateReport",
      method: "post",
      data
    });
  },

  reportCuringInsertOrUpdateReport(data){
    return request2({
      url: window.config.api2 + "/reportCuring/insertOrUpdateReport",
      method: "post",
      data
    });
  },

  //检查编号是否重复
  checkMaterialCode(params){
    return request2({
      url: window.config.api2 +"/material/checkMaterialCode",
      method: "get",
      params
    });
  },

  //设备入库
  insertOrUpdateEquipmentStore(data){
    return request2({
      url: window.config.api2 + "/equipmentStore/insertOrUpdateEquipmentStore",
      method: "post",
      data
    });
  },

  //材料入库
  insertOrUpdateMaterialStore(data){
    return request2({
      url: window.config.api2 + "/materialStore/insertOrUpdateMaterialStore",
      method: "post",
      data
    });
  },

  //查设备库存
  getEquipmentStoreByStorehouseUuid(params){
    return request2({
      url: window.config.api2 +"/equipmentStore/getEquipmentStoreByStorehouseUuid",
      method: "get",
      params
    });
  },

  //查材料库存
  getMaterialStoreByStorehouseUuid(params){
    return request2({
      url: window.config.api2 +"/materialStore/getMaterialStoreByStorehouseUuid",
      method: "get",
      params
    });
  },

  //查中控日常
  selectControlDailyInfoAll(params){
    return request2({
      url: window.config.api2 +"/selectControlDailyInfoAll",
      method: "get",
      params
    });
  },

  //查中控基本信息和时段信息
  selectControlDailyInfoAndTimeInfo(params){
    return request2({
      url: window.config.api2 +"/selectControlDailyInfoAndTimeInfo",
      method: "get",
      params
    });
  },

  //查询所有拥有突发情况的设施
  selectEmergencyDistanceAll(params){
    return request2({
      url: window.config.api2 +"/selectEmergencyDistanceAll",
      method: "get",
      params
    });
  },


  //查询详细突发事件
  selectEmetgency(params){
    return request2({
      url: window.config.api2 +"/selectEmetgency",
      method: "get",
      params
    });
  },


  //查相似
  getReportSimilarDisease(data){
    return request2({
      url: window.config.api2 + "/reportCuring/getReportSimilarDisease",
      method: "post",
      data
    });
  },

   //查二次
   getReportTwoDisease(data){
    return request2({
      url: window.config.api2 + "/reportCuring/getReportTwoDisease",
      method: "post",
      data
    });
  },

  enterReportTwoDisease(params){
    return request2({
      url: window.config.api2 + "/reportCuring/enterReportTwoDisease",
      method: "get",
      params
    });
  },

  //合并
  mergeSimilarDisease(data){
    return request2({
      url: window.config.api2 + "/reportCuring/mergeSimilarDisease",
      method: "post",
      data
    });
  },

  //二次合并
  mergeTwoDisease(data){
    return request2({
      url: window.config.api2 + "/reportCuring/mergeTwoDisease",
      method: "post",
      data
    });
  },

  //处置建议
  reportCuringDisposalSuggestion(data){
    return request2({
      url: window.config.api2 + "/reportCuring/reportCuringDisposalSuggestion",
      method: "post",
      data
    });
  },

  //获取部门
  getCompanyByCompanyId(params){
    return request2({
      url: window.config.api2 + "/company/getCompanyByCompanyId",
      method: "get",
      params
    });
  },

  insertOrUpdateReportInspection(data){
    return request2({
      url: window.config.api2 + "/reportInspection/insertOrUpdateReportInspection",
      method: "post",
      data
    });
  },

  //获取巡查任务
  getNowReportInspection(params){
    return request2({
      url: window.config.api2 + "/reportInspection/getNowReportInspection",
      method: "get",
      params
    });
  },


  //获取派单信息
  getUserInfoByDepartmentUuid(params){
    return request2({
      url: window.config.api2 + "/user/getUserInfoByDepartmentUuid",
      method: "get",
      params
    });
  },


   //派单
  insertOrUpdateReportInspectionTask(data){
    return request2({
      url: window.config.api2 + "/reportInspectionTask/insertOrUpdateReportInspectionTask",
      method: "post",
      data
    });
  },

  //获取派单信息
  getReportInspectionTaskByInspectionUuid(params){
    return request2({
      url: window.config.api2 + "/reportInspectionTask/getReportInspectionTaskByInspectionUuid",
      method: "get",
      params
    });
  },

  //根据损害类型获取维修方案
  getMaintenancePlan(params){
    return request2({
      url: window.config.api2 + "/reportCuring/getMaintenancePlan",
      method: "get",
      params
    });
  },

  //获取工序
  getProcedureByTypeUuid(params){
    return request2({
      url: window.config.api2 + "/reportCuring/getProcedureByTypeUuid",
      method: "get",
      params
    });
  },

  //新增或编辑维修方案
  insertOrUpdateReportRepairPlan(data){
    return request2({
      url: window.config.api2 + "/reportRepairPlan/insertOrUpdateReportRepairPlan",
      method: "post",
      data
    });
  },

  //维修方案回显
  getReportRepairPlanByReportId(params){
    return request2({
      url: window.config.api2 + "/reportRepairPlan/getReportRepairPlanByReportId",
      method: "get",
      params
    });
  },

  //案卷派单
  insertOrUpdateReportDispatch(data){
    return request2({
      url: window.config.api2 + "/reportDispatch/insertOrUpdateReportDispatch",
      method: "post",
      data
    });
  },

  //查询中控数据
  selectControlDailyInfo(params){
    return request2({
      url: window.config.api2 + "/selectControlDailyInfo",
      method: "get",
      params
    });
  },

  insertOrUpdateControlDailyInfo(data){
    return request2({
      url: window.config.api2 + "/insertOrUpdateControlDailyInfo",
      method: "post",
      data
    });
  },

  //查询中控时段
  selectTimeInformation(params){
    return request2({
      url: window.config.api2 + "/selectTimeInformation",
      method: "get",
      params
    });
  },

  getReportIncludeDispatch(data){
    return request2({
      url: window.config.api2 + "/reportCuring/getReportIncludeDispatch",
      method: "post",
      data
    });
  },

  insertOrUpdateTimeInformation(data){
    return request2({
      url: window.config.api2 + "/insertOrUpdateTimeInformation",
      method: "post",
      data
    });
  },

  insertOrUpdateEmergency(data){
    return request2({
      url: window.config.api2 + "/insertOrUpdateEmergency",
      method: "post",
      data
    });
  },

  getTheSameTwiceReport(data){
    return request2({
      url: window.config.api2 + "/report/getTheSameTwiceReport",
      method: "post",
      data
    });
  },

  ReportSynchronizationReportCuringTwice(params){
    return request2({
      url: window.config.api2 + "/report/ReportSynchronizationReportCuringTwice",
      method: "get",
      params
    });
  },
  // 展示及导出主城区道路日常养护工作完成情况数据
  getWorkCompletionByObj(data){
    return request2({
      url: window.config.api2 + "/workCompletion/getWorkCompletionByObj",
      method: "post",
      data
    });
  },
  // 编辑主城区道路日常养护工作完成情况数据
  updateWorkCompletion(data){
    return request2({
      url: window.config.api2 + "/workCompletion/updateWorkCompletion",
      method: "post",
      data
    });
  },
  // 导出主城区道路日常养护工作完成情况数据
  exportWorkCompletion(data){
    return request2({
      url: window.config.api2 + "/workCompletion/export",
      responseType: 'blob',
      method: "post",
      data
    });
  },
  // 导出道路日常养护计划数据
  exportMaintenancePlan(data){
    return request2({
      url: window.config.api2 + "/maintenancePlan/export",
      responseType: 'blob',
      method: "post",
      data
    });
  },
  // 导出每日道路巡查情况汇总数据
  exportInspectionSummary(data){
    return request2({
      url: window.config.api2 + "/inspectionSummary/export",
      responseType: 'blob',
      method: "post",
      data
    });
  },
  // 删除主城区道路日常养护工作完成情况数据
  deleteWorkCompletion(params){
    return request2({
      url: window.config.api2 + "/workCompletion/delete",
      method: "get",
      params
    });
  },
  // 展示及导出道路日常养护计划数据
  getMaintenancePlanByObj(data){
    return request2({
      url: window.config.api2 + "/maintenancePlan/getMaintenancePlanByObj",
      method: "post",
      data
    });
  },
  // 删除道路日常养护计划数据
  deleteMaintenancePlan(params){
    return request2({
      url: window.config.api2 + "/maintenancePlan/delete",
      method: "get",
      params
    });
  },
  // 、编辑道路日常养护计划数据
  updateMaintenancePlan(data){
    return request2({
      url: window.config.api2 + "/maintenancePlan/updateMaintenancePlan",
      method: "post",
      data
    });
  },
  // 展示每日道路巡查情况汇总数据
  getInspectionSummaryByObj(data){
    return request2({
      url: window.config.api2 + "/inspectionSummary/getInspectionSummaryByObj",
      method: "post",
      data
    });
  },
  // 编辑每日道路巡查情况汇总数据
  updateInspectionSummary(data){
    return request2({
      url: window.config.api2 + "/inspectionSummary/updateInspectionSummary",
      method: "post",
      data
    });
  },
  //
  deleteinspectionSummary(params){
    return request2({
      url: window.config.api2 + "/inspectionSummary/delete",
      method: "get",
      params
    });
  },
  // 主城区道路日常养护工作完成情况添加导入信息
  insertWorkCompletion(data){
    return request2({
      url: window.config.api2 + "/workCompletion/insertWorkCompletion",
      method: "post",
      data
    });
  },
  // 每日道路巡查情况汇总添加导入信息
  insertInspectionSummary(data){
    return request2({
      url: window.config.api2 + "/inspectionSummary/insertInspectionSummary",
      method: "post",
      data
    });
  },
  insertOrUpdateTesting: (data) => {
    return request2({
      url: window.config.api2 + "/test/insertOrUpdateTesting",
      method: "post",
      data
    });
  },

  insertFile: (data) => {
    return request2({
      url: window.config.api2 + "/file/insertFile",
      method: "post",
      data
    });
  },

  deleteFileOss(fileName){
    return request2({
      url: window.config.api2 + "/file/delete",
      method: "get",
      params: {
        fileName
      }
    });
  },

  delFileById(fileId){
    return request2({
      url: window.config.api2 + "/file/delFileById",
      method: "get",
      params: {
        fileId
      }
    });
  },

  selTesting(data){
    return request2({
      url: window.config.api2 + "/test/selTesting",
      method: "post",
      data
    });
  },

  selectAllTxl(params){
    return request2({
      url: window.config.api2 + "/selectPumpByTimeAndStatue",
      method: "get",
      params
    });
  },
  getAreaFacilityAssessByObj: (data) => {
    return request2({
      url: window.config.api2 + "/areaFacilityAssess/getAreaFacilityAssessByObj",
      method: "post",
      data
    });
  },
  insertOrUpdateAreaFacilityAssess: (data) => {
    return request2({
      url: window.config.api2 + "/areaFacilityAssess/insertOrUpdateAreaFacilityAssess",
      method: "post",
      data
    });
  },
  areaFacilityAssessdelete: (params) => {
    return request2({
      url: window.config.api2 + "/areaFacilityAssess/delete",
      method: "get",
      params
    });
  },

  getFacilitySummaryByObj: (data) => {
    return request2({
      url: window.config.api2 + "/facilitySummary/getFacilitySummaryByObj",
      method: "post",
      data
    });
  },
  insertOrUpdateFacilitySummary: (data) => {
    return request2({
      url: window.config.api2 + "/facilitySummary/insertOrUpdateFacilitySummary",
      method: "post",
      data
    });
  },
  facilitySummarydelete: (params) => {
    return request2({
      url: window.config.api2 + "/facilitySummary/delete",
      method: "get",
      params
    });
  },
  getSuperviseEvaluateByObj: (data) => {
    return request2({
      url: window.config.api2 + "/superviseEvaluate/getSuperviseEvaluateByObj",
      method: "post",
      data
    });
  },
  insertOrUpdateSuperviseEvaluate: (data) => {
    return request2({
      url: window.config.api2 + "/superviseEvaluate/insertOrUpdateSuperviseEvaluate",
      method: "post",
      data
    });
  },
  superviseEvaluatedelete: (params) => {
    return request2({
      url: window.config.api2 + "/superviseEvaluate/delete",
      method: "get",
      params
    });
  },

  getEmergentEventByObj: (data) => {
    return request2({
      url: window.config.api2 + "/emergentEvent/getEmergentEventByObj",
      method: "post",
      data
    });
  },
  insertOrUpdateEmergentEvent: (data) => {
    return request2({
      url: window.config.api2 + "/emergentEvent/insertOrUpdateEmergentEvent",
      method: "post",
      data
    });
  },
  emergentEventdelete: (params) => {
    return request2({
      url: window.config.api2 + "/emergentEvent/delete",
      method: "get",
      params
    });
  },
  getImgByObj: (data) => {
    return request2({
      url: window.config.api2 + "/img/getImgByObj",
      method: "post",
      data
    });
  },
  imgDelete: (params) => {
    return request2({
      url: window.config.api2 + "/img/delete",
      method: "get",
      params
    });
  },
  imgInsertOrUpdateImg: (data) => {
    return request2({
      url: window.config.api2 + "/img/insertOrUpdateImg",
      method: "post",
      data
    });
  },

  getFacilityImgByObj: (data) => {
    return request2({
      url: window.config.api2 + "/facilityImg/getFacilityImgByObj",
      method: "post",
      data
    });
  },

  insertOrUpdateFacilityImg: (data) => {
    return request2({
      url: window.config.api2 + "/facilityImg/insertOrUpdateFacilityImg",
      method: "post",
      data
    });
  },
  facilityImgDelete: (params) => {
    return request2({
      url: window.config.api2 + "/facilityImg/delete",
      method: "get",
      params
    });
  },
};
export default api2;

 